<div class="container">
  @if (working) {
    <div class="loading-indicator">
      <app-progress-spinner />
    </div>
  }
  <header class="button-container">
    <p-fileUpload
      [customUpload]="true"
      (uploadHandler)="handleFileUpload($event)"
      mode="basic"
      [auto]="true"
      #upload
      class="p-mr-2 mr-1"
      accept=".csv"
      chooseLabel="{{ 'CONTACT.LABEL.UPLOAD_CSV' | translate }}"
      [disabled]="!!lastUploadedFile"
    />
    <button
      pButton
      type="button"
      class="export-button p-mr-2 mr-1"
      (click)="downloadSchedule()"
      icon="pi pi-download"
      label="{{ 'COMMON.LABEL.BUTTONS.EXPORT' | translate }}"
    ></button>
    <button
      pButton
      class="p-mr-2 p-button-success mr-1"
      icon="pi pi-save"
      label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
      (click)="saveBoundChanges()"
      [disabled]="!saveEnabled"
    ></button>
    <button
      pButton
      class="p-button-danger"
      icon="pi pi-times"
      label="{{ 'COMMON.LABEL.BUTTONS.CANCEL' | translate }}"
      (click)="cancelFile()"
      [disabled]="!lastUploadedFile"
    ></button>
    <button
      pButton
      class="p-button-danger"
      icon="pi pi-trash"
      label="{{ 'CONTACT.LABEL.BULK_DELETE' | translate }}"
      (click)="openBulkDelete()"
    ></button>
  </header>

  <section>
    <p>
      {{ 'CONTACT.MESSAGES.LAST_UPLOADED_FILE' | translate }}:
      {{ lastUploadedFile?.name }}
    </p>
    <p>
      {{ 'CONTACT.MESSAGES.LAST_UPLOAD_TIME' | translate }}:
      {{ lastUploadTime | date: 'MM/dd/yyyy HH:mm' }}
    </p>
    <p id="included-header">
      {{ 'CONTACT.MESSAGES.INCLUDED_ROWS' | translate }}:
    </p>
    <div class="included-rows">
      <!-- Included rows -->
      @for (row of importedRows; track row) {
        <div class="imported-row">
          <div [ngClass]="!row.failedParse ? '' : 'warn'">
            {{ 'CONTACT.MESSAGES.USER_AD_ACCOUNT_NAME' | translate }}:
            {{ row.adAccountName }},
            {{ 'CONTACT.MESSAGES.PRIMARY_OR_SECONDARY' | translate }}:
            {{ row.primarySecondary }},
            {{ 'CONTACT.LABEL.START' | translate }}::
            {{ row.startTime | date: 'MM/dd/yyyy HH:mm' }},
            {{ 'CONTACT.LABEL.END' | translate }}::
            {{ row.endTime | date: 'MM/dd/yyyy HH:mm' }},
            {{ 'LOCATION.LABEL.TIMEZONE' | translate }}:
            {{ row.timezone }}
            @if (row.failedParse) {
              <div class="field-message">
                {{ row.failMessage }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  </section>
</div>
